import { Button, NumberBox } from 'devextreme-react';
import { useEditor } from '.';

export const Size = () => {
  const { size, template, update, zoom, setZoom } = useEditor();
  return (
    <div
      style={{
        display: 'grid',
        alignItems: 'center',
        gap: 8,
        gridTemplateColumns: '1fr 1fr 1fr',
        padding: 8,
      }}
    >
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <NumberBox
          label="Base (mm)"
          value={template.options.width}
          onValueChange={(value) => update('options.width', value)}
          width={80}
        />
        <NumberBox
          label="Altura (mm)"
          value={template.options.height}
          onValueChange={(value) => update('options.height', value)}
          width={80}
        />
      </div>
      <div style={{ textAlign: 'center' }}>
        {size.width}mm x {size.height}mm
      </div>
      <div style={{ display: 'flex', gap: 8, justifyContent: 'end', alignItems: 'center' }}>
        <Button
          disabled={zoom <= 0.5}
          icon="minus"
          onClick={() => {
            setZoom((prev) => prev - 0.25);
          }}
        />
        x{zoom.toFixed(2)}
        <Button
          disabled={zoom >= 3}
          icon="plus"
          onClick={() => {
            setZoom((prev) => prev + 0.25);
          }}
        />
      </div>
    </div>
  );
};
